__turbopack_context__.v({
  "container": "Picture-module__WabI5G__container",
  "image": "Picture-module__WabI5G__image",
});
